module.exports = __webpack_public_path__ + "img/OBCINA PESNICA.2e6994e8.png";